import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import CollapsibleSection from './CollapsibleSection';
import ScaleExercise from './ScaleExercise';
import ExerciseSequencer from './ExerciseSequencer';
import '../styles/ear-training.css';

const VocalExercises = () => {
  const { t } = useLanguage();
  const [activeTab, setActiveTab] = useState('scales');

  const activities = [
    {
      id: 'scales',
      name: t('vocalExercises.activities.scales'),
      component: ScaleExercise,
      available: true
    },
    {
      id: 'guided-exercises',
      name: t('vocalExercises.activities.exercises'),
      component: ExerciseSequencer,
      available: true
    },
    {
      id: 'arpeggios',
      name: t('vocalExercises.comingSoon.arpeggios'),
      component: null,
      available: false
    }
  ];

  const renderTabs = () => (
    <div className="ear-training-tabs">
      {activities.map((activity) => (
        <button
          key={activity.id}
          className={`tab-button ${activeTab === activity.id ? 'active' : ''} ${!activity.available ? 'disabled' : ''}`}
          onClick={() => activity.available && setActiveTab(activity.id)}
          disabled={!activity.available}
        >
          {activity.name}
          {!activity.available && <span className="coming-soon-badge">Soon</span>}
        </button>
      ))}
    </div>
  );

  const renderTabContent = () => {
    const activity = activities.find((a) => a.id === activeTab);

    if (!activity || !activity.available) {
      return (
        <div className="coming-soon-content">
          <div className="coming-soon-icon">⏳</div>
          <h3>{t('vocalExercises.comingSoon.title')}</h3>
        </div>
      );
    }

    const ActivityComponent = activity.component;
    return <ActivityComponent />;
  };

  return (
    <CollapsibleSection
      title={t('vocalExercises.title')}
      icon="🎤"
      defaultExpanded={true}
      className="ear-training-section vocal-exercises-section"
    >
      <div className="ear-training-container">
        <div className="ear-training-intro">
          <p className="ear-training-description">{t('vocalExercises.description')}</p>
        </div>

        {renderTabs()}

        <div className="tab-content">{renderTabContent()}</div>
      </div>
    </CollapsibleSection>
  );
};

export default VocalExercises;
